import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=b157066a&scoped=true&"
import script from "./aptitude.vue?vue&type=script&lang=js&"
export * from "./aptitude.vue?vue&type=script&lang=js&"
import style0 from "./aptitude.vue?vue&type=style&index=0&id=b157066a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b157066a",
  null
  
)

export default component.exports